var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1725 7.18752L6.51437 12.3344C5.85999 12.6344 6.08 13.6263 6.8 13.6263H12.375C12.4413 13.6263 12.5049 13.6526 12.5518 13.6995C12.5987 13.7464 12.625 13.81 12.625 13.8763V19.45C12.625 20.17 13.625 20.3875 13.9237 19.735L19.0625 8.07752C19.12 7.95296 19.1379 7.81375 19.1139 7.67868C19.0898 7.54361 19.0249 7.41917 18.9279 7.32215C18.8308 7.22514 18.7064 7.16021 18.5713 7.13614C18.4363 7.11206 18.2971 7.13 18.1725 7.18752Z",
    stroke: "none",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 13.125C25.125 6.5 19.75 1.125 13.125 1.125C6.5 1.125 1.125 6.5 1.125 13.125C1.125 19.75 6.5 25.125 13.125 25.125C19.75 25.125 25.125 19.75 25.125 13.125Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigate);
export default __webpack_public_path__ + "static/media/navigate.1fc6491157d2b58344c166b7a0f41365.svg";
export { ForwardRef as ReactComponent };